import React from "react";

const AppDropdown = ({
  style = {},
  width = 25,
  height = 25,
  className = "",
  color = "#888",
  viewBox = "0 0 25 25",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      style={style}
      {...rest}>
      <title>App Dropdown</title>
      <path d="M2.5,5A2.5,2.5,0,1,0,0,2.5,2.5,2.5,0,0,0,2.5,5Z" fill={color} />
      <circle cx="12.5" cy="2.5" r="2.5" fill={color} />
      <circle cx="22.5" cy="2.5" r="2.5" fill={color} />
      <circle cx="22.5" cy="12.5" r="2.5" fill={color} />
      <circle cx="12.5" cy="12.5" r="2.5" fill={color} />
      <circle cx="2.5" cy="12.5" r="2.5" fill={color} />
      <circle cx="12.5" cy="22.5" r="2.5" fill={color} />
      <circle cx="22.5" cy="22.5" r="2.5" fill={color} />
      <circle cx="2.5" cy="22.5" r="2.5" fill={color} />
    </svg>
  );
};

export default AppDropdown;
